<template>
  <AbsPopup id="PointWitherawal" title="출금 신청서 작성하기" @close="$emit('close')" @submit="submit" :initButtonList="buttonList">
    <template #body>
      <div class="popup-body">
        <div class="userInfo" v-if="page === 0">
          <span>작가님의 소득에 대한 세금 신고를 위해, 본인인증 정보를 등록한 작가님만 출금을 신청하실 수 있습니다.</span><span class="require"><u>수집한 본인인증 정보는 부가가치세법에 따라 세금계산서 발급 및 국세청 매출자료제출을 목적으로 사용됩니다.</u></span>
          <span class="line"></span>
          <div>
            <span><b>실명</b></span>
            <UInput type="text" placeholder="" v-model="name"/>
          </div>
          <div>
            <span><b>핸드폰</b></span>
            <UInput type="text" placeholder="`-` 없이 숫자만 입력하세요" v-model="phone"/>
          </div>
          <div>
            <span><b>주민등록번호</b></span>
            <UInput type="text" placeholder="`-` 없이 숫자만 입력하세요" v-model="reg"/>
          </div>
          <div>
            <span><b>은행</b></span>
            <UInput type="text" placeholder="" v-model="bank"/>
          </div>
          <div>
            <span><b>계좌번호</b></span>
            <UInput type="text" placeholder="`-` 없이 숫자만 입력하세요" v-model="banknum"/>
          </div>
          <div>
            <span><b>예금주명</b></span>
            <UInput type="text" placeholder="" v-model="bankuser"/>
          </div>
          <span class="line"></span>
          <div class="photo">
            <div>
              <span><b>신분증 이미지</b></span>
              <div v-if="idimage" class="image">
                <img id="idimage" :src="idimage" @click="openImage('idimage')"/>
              </div>
              <div v-else class="curver" @click="openImage('idimage')">
                +
              </div>
            </div>
            <div>
              <span><b>통장사본 이미지</b></span>
              <div v-if="bankimage" class="image">
                <img id="bankimage" :src="bankimage" @click="openImage('bankimage')"/>
              </div>
              <div v-else class="curver" @click="openImage('bankimage')">
                +
              </div>
            </div>
          </div>
        </div>
        <div class="pointInfo" v-else>
          <div class="pointView">
            <div>
              <span>남은 포인트</span>
              <div>
                <icon size="xsmall" uicon="edit_check" />
                <span>{{ revenuePoint + 'P' }}</span>
              </div>
            </div>
            <div>
              <span>신청 포인트</span>
              <div>
                <icon size="xsmall" uicon="edit_check" />
                <span>0P</span>
              </div>
            </div>
          </div>
          <div class="inputPoint">
            <span><b>신청 포인트</b></span>
            <UInput type="text" placeholder="출금하실 금액을 입력해 주세요" align="center" v-model="point"/>
          </div>
          <span class="line"></span>
          <div class="cert">
            <span><b>본인 인증</b></span>
            <div>
              <span>안전한 출금  서비스를 위해 본인확인 서비스를 시행하고 있습니다.<br />본인인증 확인후 출금 서비스를 신청하실 수 있습니다.</span>
              <Ubutton v-if="imp_uid === ''" size="small" text="인증하기" state="active" align="right" @click.native="certPhone"/>
            </div>
            <div v-if="imp_uid !== ''" class="result">
              <div>
                <span>이름</span>
                <span>{{ imp_name }}</span>
                <div class="agree">
                  <span>본인 인증 완료</span>
                </div>
              </div>
              <div>
                <span>생년월일</span>
                <span>{{ imp_birthDate }}</span>
                <div v-if="imp_adult" class="agree">
                  <span>성인 인증 완료</span>
                </div>
                <div v-else class="notagree">
                  <span>성인이 아닙니다</span>
                </div>
              </div>
            </div>
          </div>
          <span v-if="imp_uid !== '' && !imp_adult" class="line"></span>
          <div v-if="imp_uid !== '' && !imp_adult" class="cert">
            <span><b>부모님 인증</b></span>
            <div>
              <span>성인이 아닌경우 안전한 출금 서비스를 위해 부모님 동의 서비스를 시행하고 있습니다. 부모님 동의 인증 확인후 출금 서비스를 신청하실수 있습니다.</span>
              <Ubutton v-if="imp_adult_uid === ''" size="small" text="인증하기" state="active" align="right" @click.native="certAdult"/>
            </div>
            <div v-if="imp_adult_uid !== ''" class="result">
              <div>
                <span>이름</span>
                <span>{{ imp_adult_name }}</span>
                <div class="agree">
                  <span>본인 인증 완료</span>
                </div>
              </div>
              <div>
                <span>생년월일</span>
                <span>{{ imp_adult_birthDate }}</span>
                <div v-if="imp_adult_adult" class="agree">
                  <span>성인 인증 완료</span>
                </div>
                <div v-else class="notagree">
                  <span>성인이 아닙니다</span>
                </div>
              </div>
            </div>
          </div>
          <span class="line"></span>
          <div class="description">
            <span class="require">수익 출금은 다음과 같이 진행됩니다.</span>
            <ul>
              <li><span>출금은 1원 단위로 하실 수 있으며, 출금 가능한 최소 금액은 10,000원 입니다.</span></li>
              <li><span>출금 신청 금액에서 정산 수수료 10%를 제외한 금액이 입금됩니다.</span></li>
              <li><span>출금 승인은 1~5일정도 소요 됩니다.</span></li>
              <li><span>출금을 신청하시면 다음달 10일(휴일일 경우 이전 영업일)에 일괄적으로 처리해 드립니다.</span></li>
            </ul>
          </div>
          <span class="line"></span>
          <div class="agree">
            <input type="checkbox" id="a" v-model="check"/>
            <label for="a">
              <span>위 출금 조건 확인 및 결제진행에 동의</span>
            </label>
          </div>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
import UImageLoader from '@/components/js/UImageLoader.js'
import {getTime} from '@/components/js/Utils'

var loader = new UImageLoader()

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    loader.addForm(document.querySelector('#PointWitherawal'), 'idimage')
    loader.addForm(document.querySelector('#PointWitherawal'), 'bankimage')
    loader.addEvent('init', (id, e, param) => {
      console.log(id, param)
      var n = '#' + id
      var w = 196
      var h = 126
      var img = document.querySelector(n)
      console.log(n, img)
      if (img) {
        img.removeAttribute('width')
        img.removeAttribute('height')
      }
      this[id] = e
      setTimeout(() => {
        img = document.querySelector(n)
        if (img.width > w) {
          img.height *= w / img.width
          img.width = w
        }
        if (img.height < h) {
          img.width *= h / img.height
          img.height = h
        }
        this.isImage = false
      })
    })
    this.$emit('loading', false)
  },
  data: () => {
    return {
      page: 0,
      name: '',
      phone: '',
      reg: '',
      bank: '',
      banknum: '',
      bankuser: '',
      idimage: null,
      bankimage: null,
      point: '',
      check: false,
      imp_uid: '',
      imp_name: '',
      imp_birthDate: '',
      imp_adult: false,
      imp_adult_uid: '',
      imp_adult_name: '',
      imp_adult_birthDate: '',
      imp_adult_adult: false
    }
  },
  name: 'PointWitherawal',
  watch: {
    point (val) {
      if (parseInt(this.revenuePoint) < parseInt(val)) {
        this.point = this.revenuePoint.toString()
      }
    }
  },
  computed: {
    revenuePoint () {
      return this.option.param.revenuePoint
    },
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
        {name: this.getButtonName, state: this.isActive, click: this.submit}
      ]
    },
    getButtonName () {
      if (this.page === 0) {
        return '다음'
      } else {
        return '출금하기'
      }
    },
    isActive () {
      if (this.page === 0) {
        if (this.name !== '' && this.phone !== '' && this.reg !== '' && this.bank !== '' && this.banknum !== '' && this.bankuser !== '' && this.idimage !== null && this.bankimage !== null) {
          return 'active'
        } else {
          return 'disable'
        }
      } else {
        if (this.point !== '' && this.point !== '0' && this.imp_uid !== '' && this.check === true && (this.imp_adult === true || this.imp_adult_adult === true)) {
        // if (this.point !== '' && this.imp_uid !== '' && this.check === true && (this.imp_adult === true || this.imp_adult_adult === true)) {
          return 'active'
        } else {
          return 'disable'
        }
      }
    }
  },
  methods: {
    openImage (id) {
      loader.open(id, 1000)
    },
    certPhone () {
      this.$http.post('/api/user/proofinfo').then((e) => {
        console.log(e)
        if (e.success) {
          var o = {
            company: 'https://upenbe.com',
            merchant_uid: this.$store.getters.id + getTime()
          }
          if (e.myproof) {
            o.name = e.name
            o.phone = e.phone
            o.birth = e.birth
          }

          window.IMP.certification(o, (rsp) => {
            console.log(rsp)
            if (rsp.success) {
              // this.$http.post('/api/user/certificationInfo', {imp: rsp.imp_uid}).then((e) => {
              this.$http.post('/api/point/certificationInfo', {imp: rsp.imp_uid}).then((e) => {
                console.log(e)
                if (e.success) {
                  // this.imp_uid = 'imp_795021943051'
                  this.imp_uid = rsp.imp_uid
                  this.imp_name = e.name
                  this.imp_birthDate = e.birthDate
                  this.imp_adult = e.adult
                }
              })
            }
          })
        } else {
        }
      })
    },
    certAdult () {
      window.IMP.certification({
        company: 'https://upenbe.com',
        merchant_uid: this.$store.getters.id + getTime()
      }, (rsp) => {
        console.log(rsp)
        if (rsp.success) {
          // this.$http.post('/api/user/certificationInfo', {imp: this.imp_uid}).then((e) => {
          this.$http.post('/api/point/certificationInfo', {imp: rsp.imp_uid}).then((e) => {
          // this.$http.post('/api/point/certificationInfo', {imp: 'imp_795021943051'}).then((e) => {
            console.log(e)
            if (e.success) {
              // this.imp_adult_uid = 'imp_795021943051'
              this.imp_adult_uid = rsp.imp_uid
              this.imp_adult_name = e.name
              this.imp_adult_birthDate = e.birthDate
              this.imp_adult_adult = e.adult
            }
          })
        }
      })
    },
    submit () {
      if (this.isActive === 'active' && this.page === 0) {
        this.page = 1
      } else if (this.isActive === 'active') {
        var form = new FormData()
        form.append('idcard', UImageLoader.dataURLToBlob(this.idimage))
        form.append('bank', UImageLoader.dataURLToBlob(this.bankimage))
        form.append('name', this.name)
        form.append('phone', this.phone)
        form.append('reg', this.reg)
        form.append('bank', this.bank)
        form.append('banknum', this.banknum)
        form.append('bankuser', this.bankuser)
        form.append('point', this.point)
        form.append('imp_uid', this.imp_uid)
        form.append('imp_adult_uid', this.imp_adult_uid)
        this.$http.post('/api/point/withdrawal', form, {headers: {'Content-Type': 'multipart/form-data'}}).then((e) => {
          console.log(e)
          if (e.success) {
            this.$emit('submit', {})
          } else {
          }
        })
      }
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
.popup-body {
  margin: 10px 20px;
  width: 590px;
  text-align: left;
  line-height: 30px;
}
.popup-body .line {
  margin: 20px 0px;
  width: 100%;
  display: flex;
  border-bottom: 1px solid var(--line-base);
}
.userInfo > div {
  display: flex;
  flex-direction: row;
  margin: 10px 0px;
}
.userInfo > div > span:first-child {
  width: 150px;
}
.userInfo > div .input {
  border: 1px solid var(--line-base);
  border-radius: 3px;
  flex: 1;
  padding-left: 10px;
}
.userInfo .photo > div {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.userInfo .photo > div:first-child {
  margin-right: 30px;
}
.userInfo .photo .curver {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border: 1px solid var(--line-base);
  cursor: pointer;
  height: 180px;
  width: 280px;
}
.userInfo .photo .image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 180px;
  width: 280px;
  border: 1px solid var(--line-base);
  overflow: hidden;
  cursor: pointer;
}
.userInfo .photo img {
  display: flex;
}
.pointInfo > div {
  margin-left: 10px;
}
.pointInfo .pointView {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-left: 0px;
  margin-bottom: 10px;
}
.pointInfo .pointView > div {
  display: flex;
  flex-direction: column;
  flex: 1;
  border: 1px solid var(--line-base);
  padding: 10px;
  line-height: 30px;
}
.pointInfo .pointView > div:first-child {
  margin-right: 10px;
}
.pointInfo .pointView > div > div {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.pointInfo .pointView > div > div > span:last-child {
  margin-left: auto;
  font-weight: bold;
  font-size: 20px;
}
.inputPoint {
  display: flex;
  flex-direction: row;
}
.inputPoint .input {
  flex: 1;
  border: 1px solid var(--line-base);
  border-radius: 3px;
  margin: 0px 20px;
}
.cert > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 10px;
  line-height: 25px;
}
.cert .result {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid var(--line-base);
  line-height: 35px;
  margin-top: 10px;
}
.cert .result > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 0px 10px;
}
.cert .result > div span {
  flex: 1;
}
.cert .result .agree {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  color: var(--active);
}
.cert .result .agree::before {
  content: '\2714';
  color: var(--bg-white);
  position: absolute;
  line-height: 14px;
  width: 14px;
  height: 14px;
  border-radius:14px;
  background-color: var(--active);
  left: 0px;
  text-align: center;
  top: 50%;
  font-size: 8px;
  transform: translateY(-50%);
}
.cert .result .notagree {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  color: var(--require);
}
.cert .result .notagree::before {
  content: 'x';
  color: var(--bg-white);
  position: absolute;
  line-height: 14px;
  width: 14px;
  height: 14px;
  border-radius:14px;
  background-color: var(--require);
  left: 0px;
  text-align: center;
  top: 50%;
  font-size: 8px;
  transform: translateY(-50%);
}
.description ul {
  margin-left: 18px;
}
.pointInfo > .agree {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.pointInfo > .agree input[type=checkbox] {
  display: none;
}
.pointInfo > .agree input[type=checkbox] + label {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  cursor: pointer;
}
.pointInfo > .agree input[type=checkbox] + label::before {
  content: '';
  color: var(--line-base);
  position: absolute;
  line-height: 14px;
  width: 14px;
  height: 14px;
  border-radius:14px;
  border: 2px solid var(--line-base);
  left: 0px;
  text-align: center;
  top: 50%;
  font-size: 14px;
  transform: translateY(-50%);
}
.pointInfo > .agree input[type=checkbox]:checked + label::before {
  content: 'v';
  color: var(--active);
  border: 2px solid var(--active);
}
.pointInfo > .agree input[type=checkbox]:checked + label {
  color: var(--active);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PointWitherawal.vue